import _classNames from "classnames";

const classNames = _classNames;

export default classNames;
